/**
 * @file Renders a small warning line with an exclamation icon.
 */
import React from "react";
import { Space } from "antd";
import type { CSSProperties } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import Small from "./Small";

type Props = {
  text: string;
  style?: CSSProperties;
};

const MARGIN_TOP = 4;
const LINE_HEIGHT = 1.2;

/**
 * Renders the text next to a warning icon, as a small disclaimer line.
 */
const Disclaimer = ({ text, style: styleCustom = {} }: Props): JSX.Element => {
  const style: CSSProperties = {
    marginTop: MARGIN_TOP,
    lineHeight: LINE_HEIGHT,
    alignItems: "start",
    ...styleCustom,
  };

  return (
    <Space style={style}>
      <ExclamationCircleOutlined />
      <Small>{text}</Small>
    </Space>
  );
};

export default Disclaimer;
